import DashboardRoutes from "./DashboardRoutes";

export { DashboardRoutes };
